import React from 'react';
import { ActionIcon, Card, Text, useMantineTheme, Menu, Group, SimpleGrid } from '@mantine/core';
import { IconDotsVertical } from '@tabler/icons-react';

import { utils } from '../../utils/globalVariables';
import { sqlDateToHumanDate, numberWithComma, getValuePropInObj } from "../../utils/globalFunctions";

import LabelContentInline from "../../components/general/LabelContentInline";
import SortSegmentedControl from "../../components/general/SortSegmentedControl";

const DiscountSpecialCard = ({ stateData, stateSortList, stateSortSelected, fnSort, fnSelectedDataEdit, fnSelectedDataDelete, fnSelectedDataView }) => {

  const theme = useMantineTheme();

  return (
    <React.Fragment>

      <SortSegmentedControl
        stateSortList={stateSortList}
        stateSortSelected={stateSortSelected}
        fnSort={fnSort}
        stateStyle={{ marginBottom: theme.spacing.md }}
      />

      <SimpleGrid
        cols={1}
        spacing='md'
        breakpoints={[
          { minWidth: 'xl', cols: 4, spacing: 'md' },
          { minWidth: 'lg', cols: 3, spacing: 'md' },
          { minWidth: 'md', cols: 3, spacing: 'md' },
          { minWidth: 'sm', cols: 2, spacing: 'md' },
          { minWidth: 'xs', cols: 2, spacing: 'md' },
        ]}
      >
        {Object.keys(stateData).map((key, index) => {
          return (
            <Card
              key={key}
              shadow=''
              radius="md"
              withBorder={true}

              style={{
                borderColor: theme.colorScheme === 'light' ? theme.colors.gray[2] : theme.colors.dark[7],
                backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7],
                overflow: 'unset',
                cursor: 'pointer',
              }}

              onClick={() => {
                fnSelectedDataView(stateData[key]);
              }}
            >
              <Card.Section p='sm'>
                <Text size="sm">
                  <LabelContentInline
                    stateColLabel={4}
                    stateLabel={stateSortList.name.caption}
                    stateContent={
                      <Group position='apart' noWrap>
                        <Text style={{ wordBreak: 'break-word' }} size='xs'>
                          {stateData[key].diskon_code_prefix}
                        </Text>

                        <Menu shadow="md" width={200}>
                          <Menu.Target>
                            <ActionIcon
                              size='md'
                              variant="subtle"
                              radius='xl'

                              sx={{
                                '&:hover': {
                                  backgroundColor: theme.colorScheme === 'light' ? theme.colors.gray[1] : theme.colors.dark[5]
                                },
                              }}

                              onClick={(e) => {
                                e.stopPropagation();
                              }}
                            >
                              <IconDotsVertical size='1rem' />
                            </ActionIcon>
                          </Menu.Target>

                          <Menu.Dropdown>
                            <Menu.Item
                              onClick={(e) => {
                                e.stopPropagation();
                                fnSelectedDataEdit(stateData[key]);
                              }}
                            >
                              Edit
                            </Menu.Item>

                            <Menu.Item
                              onClick={(e) => {
                                e.stopPropagation();
                                fnSelectedDataDelete(stateData[key])
                              }}
                            >
                              Delete
                            </Menu.Item>
                          </Menu.Dropdown>
                        </Menu>
                      </Group>
                    }
                    stateDivider={false}
                  />

                  <LabelContentInline
                    stateColLabel={4}
                    stateLabel='Diskon'
                    stateContent={
                      stateData[key].diskon_type === utils.discountType.rupiah.value ? `Rp ${numberWithComma(Number(stateData[key].diskon_value))}` : `${Number(stateData[key].diskon_value)}%`
                    }
                    stateDivider={false}
                  />

                  <LabelContentInline
                    stateColLabel={4}
                    stateLabel='Dari'
                    stateContent={getValuePropInObj(utils.discountDeductedFrom, 'value', stateData[key].diskon_deducted_from, 'label', ' - ')}
                    stateDivider={false}
                  />

                  <LabelContentInline
                    stateColLabel={4}
                    stateLabel={stateSortList.dateCreated.caption}
                    stateContent={
                      sqlDateToHumanDate({
                        stateDate: stateData[key].diskon_date_created,
                        stateWithTime: false,
                        stateLang: 'id',
                        stateIsShort: true,
                        stateDay: false,
                        stateDefaultValue: ' - ',
                        stateDateType: 'day',
                        stateWithSecond: false
                      })
                    }
                    stateDivider={false}
                  />

                  <LabelContentInline
                    stateColLabel={4}
                    stateLabel='Status'
                    stateContent={stateData[key].diskon_is_active === '1' ? 'Aktif' : 'Non Aktif'}
                    stateDivider={false}
                  />
                </Text>
              </Card.Section>
            </Card>
          )
        })}
      </SimpleGrid>
    </React.Fragment>
  )
}

export default React.memo(DiscountSpecialCard);